/* CO2Art — Track your order (sections/track-order.liquid), 2026-09-11, redesigned the same day.
   Plan: co2art-ai docs/plans/2026-09-11-track-order-redesign.md (order-processing R124 / R125).
   One form-encoded POST to our public tracking service (a SIMPLE request — a safelisted content type, no custom header, no
   credentials — the gateway answers CORS for the store origins on that route only), then the answer drawn into the page: the arrival line, a four-stop rail,
   and per parcel the journey map (country outlines and stops come from our own endpoint, already projected) beside the
   carrier's scans. Every string the API returns is inserted as a text node; the only API values that reach an attribute are
   the map's own path geometry and the carrier URL, both checked first. Reads ?order= and searches on load when the e-mail is
   known, so the shipping e-mails can link straight to a result. Concept swaps the DOM on page transitions and re-executes
   injected scripts: the define is guarded and connectedCallback runs once per element.
   2026-09-22 (co2art-ai clean audit #1 / F77, plan 2026-09-22-us-clean-audit-fixes-PLAN.md A1-b): the e-mail never travels in a
   URL. snippets/url-privacy.liquid takes ?email= out of the address bar before any tag reads it and leaves it in this tab's
   sessionStorage stash, read once here; the lookup is a POST with a form-encoded body (still a CORS-simple request — no
   preflight), so the address is in no query string, access log or Referer either. */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('track-order')) return;

  var SVG = 'http://www.w3.org/2000/svg';
  var STAGES = ['label_created', 'in_transit', 'out_for_delivery', 'delivered'];
  var SAFE_PATH = /^[Mm][-0-9.,\sLlQqZz]*$/;
  var DAY = 86400000;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null && text !== '') n.textContent = String(text);
    return n;
  }
  function svg(tag, attrs) {
    var n = document.createElementNS(SVG, tag);
    for (var k in attrs) if (attrs[k] !== null && attrs[k] !== undefined) n.setAttribute(k, attrs[k]);
    return n;
  }
  function fill(template, values) {
    return String(template || '').replace(/\[(\w+)\]/g, function (m, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : m;
    });
  }
  function parseDate(iso) {
    if (!iso) return null;
    var d = new Date(iso);
    return isNaN(d.getTime()) ? null : d;
  }
  function startOfDay(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime(); }
  // The value snippets/url-privacy.liquid took out of THIS page's URL (same path, under 10 minutes old), removed as it is read.
  function takeStashed(key) {
    try {
      var raw = sessionStorage.getItem('co2art_url_stash');
      if (!raw) return '';
      var st = JSON.parse(raw) || {};
      var v = st.v || {};
      if (st.p !== window.location.pathname || Date.now() - (st.t || 0) > 600000 || !v[key]) return '';
      var out = String(v[key]);
      delete v[key];
      if (Object.keys(v).length) sessionStorage.setItem('co2art_url_stash', JSON.stringify(st));
      else sessionStorage.removeItem('co2art_url_stash');
      return out;
    } catch (e) { return ''; }
  }

  class TrackOrder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.api = (this.dataset.api || '').replace(/\/+$/, '');
      // Dates follow the STORE's locale (data-lang), not the document's: on a GTranslate mirror the
      // document says "de" while everything this script writes stays English, and "Arriving Dienstag"
      // is worse than "Arriving Tuesday". A bare "en" would make Intl print "September 15"; the shop's
      // customers read "15 September", so it becomes en-GB.
      var tag = this.dataset.lang || document.documentElement.lang || 'en';
      this.lang = /^en$/i.test(tag) ? 'en-GB' : tag;
      try { this.words = JSON.parse(this.dataset.words || '{}'); } catch (e) { this.words = {}; }
      this.steps = String(this.words.steps || 'Label made,On the way,Out for delivery,Delivered')
        .split(',').map(function (s) { return s.trim(); });
      this.form = this.querySelector('[data-form]');
      this.orderInput = this.querySelector('[data-order]');
      this.emailInput = this.querySelector('[data-email]');
      this.submit = this.querySelector('[data-submit]');
      this.status = this.querySelector('[data-status]');
      this.result = this.querySelector('[data-result]');
      if (!this.form || !this.orderInput || !this.emailInput) return;

      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.lookup(); });

      var q = null;
      try { q = new URLSearchParams(window.location.search); } catch (e) {}
      var o = q ? (q.get('order') || '').trim() : '';
      // the head snippet has already moved ?email= / ?k= into the stash; the URL is only read if that snippet did not run
      var m = (takeStashed('email') || (q && q.get('email')) || '').trim();
      // k = the order's own secret key (Shopify's order token) — the shipping mails carry it instead of the e-mail since
      // 2026-09-22; it opens THAT order only, so it is kept with the order it came with and never shown in the form
      var k = (takeStashed('k') || (q && q.get('k')) || '').trim();
      if (k && o) { this.key = k; this.keyOrder = o; }
      if (o) this.orderInput.value = o;
      if (m) this.emailInput.value = m;
      if (o && (m || this.key)) this.lookup();
    }

    // ── talking to the service ────────────────────────────────────────────────

    say(text, kind) {
      if (!this.status) return;
      this.status.textContent = text || '';
      this.status.className = 'track__status alert alert--' + (kind || 'info') +
        ' flex items-start gap-3 text-sm md:text-base leading-tight';
      this.status.hidden = !text;
    }

    busy(on) {
      if (!this.submit) return;
      this.submit.disabled = !!on;
      this.submit.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    lookup() {
      var self = this;
      var order = (this.orderInput.value || '').trim();
      var email = (this.emailInput.value || '').trim();
      var useKey = !email && !!this.key && order === this.keyOrder;
      if (!order || (!useKey && (!email || email.indexOf('@') < 1))) {
        this.say(this.words.invalid, 'error');
        (order ? this.emailInput : this.orderInput).focus();
        return;
      }
      if (!this.api || !window.fetch) { this.say(this.words.unavailable, 'error'); return; }

      var body = 'order=' + encodeURIComponent(order) +
        (useKey ? '&k=' + encodeURIComponent(this.key) : '&email=' + encodeURIComponent(email));
      var token = (this._token = (this._token || 0) + 1);
      this.busy(true);
      this.result.hidden = true;
      this.result.textContent = '';
      this.say(this.words.loading, 'info');

      fetch(this.api, {
        method: 'POST', body: body, credentials: 'omit', cache: 'no-store',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
        .then(function (resp) {
          if (token !== self._token) return;
          if (resp.status === 200) return resp.json().then(function (b) { self.render(b); });
          if (resp.status === 404) { self.say(self.words.empty, 'error'); return; }
          if (resp.status === 429) {
            var retry = parseInt(resp.headers.get('Retry-After') || '0', 10);
            var text = self.words.limited || '';
            if (retry > 0) text += ' (' + Math.max(1, Math.ceil(retry / 60)) + ' min)';
            self.say(text, 'error');
            return;
          }
          self.say(self.words.unavailable, 'error');
        })
        .catch(function () { if (token === self._token) self.say(self.words.unavailable, 'error'); })
        .then(function () { if (token === self._token) self.busy(false); });
    }

    // ── words ─────────────────────────────────────────────────────────────────

    date(iso, withWeekday) {
      var d = parseDate(iso);
      if (!d) return '';
      var opts = withWeekday ? { weekday: 'long', day: 'numeric', month: 'long' } : { day: 'numeric', month: 'long' };
      try { return new Intl.DateTimeFormat(this.lang, opts).format(d); } catch (e) { return d.toLocaleDateString(); }
    }

    time(iso) {
      var d = parseDate(iso);
      if (!d) return '';
      try { return new Intl.DateTimeFormat(this.lang, { hour: '2-digit', minute: '2-digit' }).format(d); }
      catch (e) { return d.toLocaleTimeString(); }
    }

    /* The one line that answers "when". Each branch is a real state of the parcel,
       so the page never says "on the way" about something already delivered. */
    headline(shipment) {
      var w = this.words;
      var status = shipment && shipment.status;
      if (status === 'delivered') {
        var on = shipment.status_at ? fill(w.delivered_on, { date: this.date(shipment.status_at, true) }) : null;
        return on || w.delivered_on.replace(/\s*\[date\]/, '');
      }
      if (status === 'returned') return w.returning;
      if (status === 'exception') return w.delayed;
      if (status === 'out_for_delivery') return w.out_today;
      if (shipment && shipment.eta) {
        var eta = parseDate(shipment.eta);
        if (eta) {
          var days = Math.round((startOfDay(eta) - startOfDay(new Date())) / DAY);
          if (days <= 0) return w.arriving_today;
          return fill(w.arriving, { date: this.date(shipment.eta, true) });
        }
      }
      if (status === 'in_transit') return w.on_the_way;
      if (status === 'label_created') return w.preparing;
      return w.unknown;
    }

    /* The stage the rail should light. A parcel that came back or went wrong keeps
       the stages it reached and lights none of the rest. */
    stageOf(shipment) {
      var i = STAGES.indexOf(shipment && shipment.status);
      if (i >= 0) return i;
      if (shipment && (shipment.status === 'returned' || shipment.status === 'exception')) return 1;
      return 0;
    }

    // ── drawing ───────────────────────────────────────────────────────────────

    render(body) {
      var self = this;
      this.result.textContent = '';
      if (!body || !body.found || !body.order) { this.say(this.words.empty, 'error'); return; }
      this.say('', 'info');

      var order = body.order;
      var shipments = Array.isArray(body.shipments) ? body.shipments : [];
      var lead = shipments[0] || null;

      var hero = el('header', 'track__hero');
      hero.appendChild(el('p', 'track__headline', this.headline(lead)));
      var subTemplate = shipments.length > 1 ? this.words.sub_many : this.words.sub_one;
      hero.appendChild(el('p', 'track__sub', fill(subTemplate, {
        order: String(order.name || '').replace(/^#/, ''),
        date: this.date(order.placed_at, false),
        count: shipments.length
      })));
      this.result.appendChild(hero);

      if (!shipments.length) {
        this.result.appendChild(el('p', 'track__empty', this.words.no_scans));
      }
      shipments.forEach(function (s, i) {
        self.result.appendChild(self.parcel(s, i, shipments.length));
      });
      this.result.hidden = false;
    }

    parcel(shipment, index, total) {
      var wrap = el('section', 'track__parcel');
      if (total > 1) {
        wrap.appendChild(el('p', 'track__parcel-of', fill(this.words.parcel_of, { n: index + 1, count: total })));
      }
      wrap.appendChild(this.rail(shipment));

      var body = el('div', 'track__body');
      var map = this.map(shipment);
      if (map) body.appendChild(map);
      body.appendChild(this.side(shipment));
      wrap.appendChild(body);
      return wrap;
    }

    rail(shipment) {
      var reached = this.stageOf(shipment);
      var list = el('ol', 'track__rail');
      this.steps.forEach(function (label, i) {
        var li = el('li', 'track__step' + (i <= reached ? ' is-done' : '') + (i === reached ? ' is-now' : ''));
        li.appendChild(el('span', 'track__step-label', label));
        if (i === reached) li.setAttribute('aria-current', 'step');
        list.appendChild(li);
      });
      return list;
    }

    map(shipment) {
      var m = shipment && shipment.map;
      if (!m || !Array.isArray(m.stops) || !m.stops.length) return null;
      var w = Number(m.w) || 1000;
      var h = Number(m.h) || 620;

      var figure = el('figure', 'track__map');
      var frame = el('div', 'track__map-frame');
      frame.style.aspectRatio = w + ' / ' + h;
      var node = svg('svg', { viewBox: '0 0 ' + w + ' ' + h, role: 'img', focusable: 'false' });
      node.setAttribute('aria-label', this.mapLabel(m));

      var land = svg('g', { class: 'track__land' });
      (m.land || []).forEach(function (d) {
        if (typeof d === 'string' && SAFE_PATH.test(d)) land.appendChild(svg('path', { d: d }));
      });
      node.appendChild(land);

      if (typeof m.route === 'string' && SAFE_PATH.test(m.route)) {
        var route = svg('path', { class: 'track__route', d: m.route });
        node.appendChild(route);
        this._route = route;
      }

      var current = null;
      m.stops.forEach(function (s) {
        var x = Number(s.x), y = Number(s.y);
        if (!isFinite(x) || !isFinite(y)) return;
        if (s.current) {
          node.appendChild(svg('circle', { class: 'track__halo', cx: x, cy: y, r: 16 }));
          current = s;
        }
        node.appendChild(svg('circle', {
          class: 'track__stop' + (s.current ? ' track__stop--now' : ''),
          cx: x, cy: y, r: s.current ? 7 : 4.5
        }));
      });
      frame.appendChild(node);

      if (current && current.label) {
        // the label sits above its dot, but a dot near an edge would push it out of
        // the frame — near the sides it hangs off the dot instead of straddling it
        var px = current.x / w * 100;
        var pin = el('span', 'track__pin', current.label);
        var anchor = px < 22 ? '-8%' : (px > 78 ? '-92%' : '-50%');
        pin.style.left = px.toFixed(2) + '%';
        pin.style.top = (current.y / h * 100).toFixed(2) + '%';
        pin.style.transform = 'translate(' + anchor + ', -140%)';
        frame.appendChild(pin);
        // a long name can still reach past the frame — measure once and nudge it back in
        requestAnimationFrame(function () {
          var box = pin.getBoundingClientRect();
          var bounds = frame.getBoundingClientRect();
          var over = Math.max(0, bounds.left + 6 - box.left) - Math.max(0, box.right - bounds.right + 6);
          if (over) pin.style.marginLeft = Math.round(over) + 'px';
        });
      }
      figure.appendChild(frame);
      if (m.coarse && this.words.coarse) {
        figure.appendChild(el('figcaption', 'track__map-note', this.words.coarse));
      }
      // the route draws itself once; the length has to be measured after it is in the document
      if (this._route) {
        var path = this._route;
        this._route = null;
        requestAnimationFrame(function () {
          try { path.style.setProperty('--len', path.getTotalLength()); } catch (e) {}
        });
      }
      return figure;
    }

    mapLabel(m) {
      var names = (m.stops || []).map(function (s) { return s.label; }).filter(Boolean);
      return names.length ? names.join(' — ') : 'Map of the parcel journey';
    }

    side(shipment) {
      var side = el('div', 'track__side');

      var carrier = el('p', 'track__carrier');
      if (shipment.carrier) carrier.appendChild(el('b', null, shipment.carrier));
      if (shipment.tracking_number) carrier.appendChild(el('span', 'track__number', shipment.tracking_number));
      if (carrier.childNodes.length) side.appendChild(carrier);

      var events = Array.isArray(shipment.events) ? shipment.events : [];
      if (events.length) {
        var list = el('ol', 'track__events');
        var day = null, group = null;
        var self = this;
        events.forEach(function (ev) {
          var d = parseDate(ev.at);
          var key = d ? startOfDay(d) : 'none';
          if (key !== day) {
            day = key;
            group = el('li');
            group.appendChild(el('p', 'track__day', d ? self.date(ev.at, false) : ''));
            list.appendChild(group);
          }
          var row = el('div', 'track__scan');
          row.appendChild(el('span', 'track__time', self.time(ev.at)));
          var text = el('span', 'track__scan-text', ev.text || '');
          if (ev.place) text.appendChild(el('span', 'track__scan-place', ev.place));
          row.appendChild(text);
          group.appendChild(row);
        });
        side.appendChild(list);
      } else {
        side.appendChild(el('p', 'track__empty', this.words.no_scans));
      }

      if (shipment.carrier_url && /^https:\/\//.test(shipment.carrier_url)) {
        var p = el('p', 'track__side-link');
        var a = el('a', 'link', this.words.link);
        a.href = shipment.carrier_url;
        a.target = '_blank';
        a.rel = 'noopener nofollow';
        p.appendChild(a);
        side.appendChild(p);
      }
      return side;
    }
  }

  customElements.define('track-order', TrackOrder);
})();
